import React from "react";
import OrganiserTeamSection from "./OrganiserTeamSection";

const OrganizerTeamPagePage = () => {
  return (
    <main className="min-h-screen bg-white">
      <OrganiserTeamSection />
    </main>
  );
};

export default OrganizerTeamPagePage;